import React from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect
} from 'react-router-dom';
import { withCookies, Cookies } from 'react-cookie';

import './App.css';

import Routers from './router/RouterMap'
import { Index } from './components/MyPages';

class App extends React.Component {

    sid;

    constructor(props) {
        super(props)
        if (window.location.search) {
            let strSearch = window.location.search;
            let params = strSearch.substring(1, strSearch.length).split('&');
            if (params) {
                params.map((item, i) => item.split('=')[0] === 'sid' ? this.sid = item.split('=')[1] : "");
            }
        }
    }

    render() {
        const { cookies } = this.props;

        // 
        // let token = "0239f0cea6d666746658046ea76e4dd4";
        // cookies.set(process.env.TOKEN_KEY, token, { path: '/' });

        let token = cookies.get(process.env.TOKEN_KEY);

        if (!token && this.sid) {
            token = this.sid;
            cookies.set(process.env.TOKEN_KEY, token, { path: '/' });
        }

        return <Router>
            <Switch>
                {
                    Routers.map((item, index) => {
                        return <Route key={index} path={item.path} exact render={props => (!item.auth ? (<item.component {...props} />) : (token ? <item.component {...props} /> : <Redirect to={{ pathname: '/login', state: { from: props.location, params: window.location.search } }} />))} />
                    })
                }
                <Route component={Index} />
            </Switch>
        </Router>
    }

}

export default withCookies(App);